import { addDays, endOfMonth, startOfDay, startOfMonth, startOfWeek } from 'date-fns';
import type { Session } from '@timato/shared';

export type Scope = 'today' | 'week' | 'month';
export type Range = { from: Date; to: Date };

/** Half-open [from, to) range for a scope around `anchor`. Weeks start on Monday. */
export function rangeFor(scope: Scope, anchor: Date): Range {
  if (scope === 'today') { const from = startOfDay(anchor); return { from, to: addDays(from, 1) }; }
  if (scope === 'week') { const from = startOfWeek(anchor, { weekStartsOn: 1 }); return { from, to: addDays(from, 7) }; }
  const from = startOfMonth(anchor); return { from, to: addDays(startOfDay(endOfMonth(anchor)), 1) };
}

/** Focus and track sessions count as work; breaks do not. */
export const isWork = (s: Session) => s.mode === 'focus' || s.mode === 'track';

export const sumSec = (sessions: Session[]) => sessions.reduce((a, s) => a + s.durationSec, 0);

export function groupSum<K>(sessions: Session[], key: (s: Session) => K): Map<K, number> {
  const m = new Map<K, number>();
  for (const s of sessions) m.set(key(s), (m.get(key(s)) ?? 0) + s.durationSec);
  return m;
}

/** Rows that carry every selected label (AND filter). */
export const matchesAll = (labelIds: string[], selected: string[]) => selected.every((id) => labelIds.includes(id));

/** Share of a total as a whole percentage; 0 when the total is 0. */
export const share = (part: number, total: number) => (total > 0 ? Math.round((part / total) * 100) : 0);
